module.exports = __webpack_public_path__ + "static/media/AP_NES_Z1.827453b1.png";